import React, { useState } from "react";
import { ZoomIn } from "react-feather";
import { imagesType } from "../type";
import ReactImageZoom from "react-image-zoom";

const GalleryDesktop = ({ images }) => {
    const [previewIdx, setPreviewIdx] = useState(0);

    const zoomConfig = {
        width: 420,
        height: 660,
        zoomWidth: 420,
        img: images[previewIdx].src,
        zoomPosition: "original",
        offset: { vertical: 10, horizontal: 0 },
    };

    return (
        <div className="desktop-gallery">
            <div className="thumbnails">
                {images.map((image, i) => {
                    return (
                        <img
                            className={i === previewIdx ? "" : "low-opacity"}
                            alt="image"
                            src={image.src}
                            key={i}
                            onClick={() => setPreviewIdx(i)}
                        />
                    );
                })}
            </div>
            <div className="preview-image">
                <div className="inspect-icon">
                    <ZoomIn size={18} />
                </div>
                <ReactImageZoom {...zoomConfig} />
            </div>
        </div>
    );
};

GalleryDesktop.propTypes = imagesType;
export default GalleryDesktop;
